
// @ts-nocheck
import locale_zh_46json_d71d100b from "#nuxt-i18n/d71d100b";
import locale_en_46json_7c313451 from "#nuxt-i18n/7c313451";
import locale_id_46json_ddf74f09 from "#nuxt-i18n/ddf74f09";

export const localeCodes =  [
  "zh",
  "en",
  "id"
]

export const localeLoaders = {
  zh: [
    {
      key: "locale_zh_46json_d71d100b",
      load: () => Promise.resolve(locale_zh_46json_d71d100b),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_7c313451",
      load: () => Promise.resolve(locale_en_46json_7c313451),
      cache: true
    }
  ],
  id: [
    {
      key: "locale_id_46json_ddf74f09",
      load: () => Promise.resolve(locale_id_46json_ddf74f09),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "zh",
      name: "中文",
      language: "zh-CN",
      files: [
        {
          path: "/opt/source_www_file/www-sanfu-html/i18n/locales/zh.json",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      name: "English",
      language: "en-US",
      files: [
        {
          path: "/opt/source_www_file/www-sanfu-html/i18n/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "id",
      name: "Bahasa Indonesia",
      language: "id-ID",
      files: [
        {
          path: "/opt/source_www_file/www-sanfu-html/i18n/locales/id.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "zh",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "zh",
    name: "中文",
    language: "zh-CN",
    files: [
      {
        path: "/opt/source_www_file/www-sanfu-html/i18n/locales/zh.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    name: "English",
    language: "en-US",
    files: [
      {
        path: "/opt/source_www_file/www-sanfu-html/i18n/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "id",
    name: "Bahasa Indonesia",
    language: "id-ID",
    files: [
      {
        path: "/opt/source_www_file/www-sanfu-html/i18n/locales/id.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/